/*
 *  Document   : consultant-activities-registrations-error.js
 *  Author     : Exapoint
 *
 */

// Import required modules

import ExaHelpers from "../exa_helpers";

export default class ConsultantActivitiesRegistrationsError {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ConsultantActivitiesRegistrations"] = this
        this.dateFilterFrom = null;
        this.dateFilterTo = null;
        this.disabledOnly = false;
        this.init();
    }

    init() {
        $('.js-dataTable-full-pagination').DataTable({
            ajax: {
                url: jsVars.datatablesAjax,
                /*data: function (d) {
                    return $.extend({}, d, {
                        "dateFromFilter": ConsultantActivitiesRegistrations.dateFromFilter,
                        "dateToFilter": ConsultantActivitiesRegistrations.dateToFilter,
                        "disabledOnly": ConsultantActivitiesRegistrations.disabledOnly,
                    });
                }*/
            },
            order: [[0, "desc"]],
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [         
                {
                    data: 'id'
                },
                {
                    data: 'first_name'
                },
                {
                    data: 'last_name'
                },    
                {
                    data: 'email',
                    render: function (data, type, row) {
                        return `<a href="mailto:${data}" class="text-color-table">${data}</a>`;
                    }
                },
                {
                    data: 'mobile_number',
                    render: function (data, type, row) {
                        return `<a href="tel:${data}" class="text-color-table">${data}</a>`;
                    }
                },
                {
                    data: 'created_at',
                    render: function (data, type, row) {
                        return new Date(data).toLocaleString('de-CH');
                    }
                },
                 {
                    data: 'id',
                    render: function (data, type, row) {
                        
                        return `<a onclick="return confirm('${jsVars.confirm}')" href="/app/consultant/inscription/supprimer/${row.id} " class="btn btn-primary btn-tag duplique btn-table">${jsVars.deleteThisUser}</a>`;
                       
                    }
                },

            ],
            "columnDefs": [
                {
                    "targets": [ 0 ],
                    "visible": false,
                    "searchable": true
                }
            ],
            drawCallback: function () {
                $('.dataTables_length').css({ top: '-63px' })
                if (!this.api().data().length) {
                    $('.dataTables_paginate .pagination').css('visibility', 'hidden');
                }
             },
            processing: true,
            serverSide: true,
            lengthChange: true,
            lengthMenu: [ 10, 25, 50, 100, 1000 ] ,
            autoWidth: false,
            responsive: true,
            dom: 'frtiplB',
            buttons: [
                {
                   extend: 'csvHtml5',
                   footer: false,
                   exportOptions: {
                        columns: [0,1,2,3,4,5]
                    }
               }
            ],
            initComplete: function () {
                let api = this.api();
                let $container = $(this.api().table().container()).find('.dataTables_filter');

                // modify DT filter styling
                this.parents('.dataTables_wrapper').find('.dataTables_filter').parent().get(0).classList = 'col-12 dataTables_wrapper dt-bootstrap4 no-footer';
            }
        });
        let $editUserModal = $('#consultant-activities-edit-user-modal');
        $editUserModal.on('show.bs.modal', function (e) {
            let $modal = $(e.target);
            let $target = $(e.relatedTarget).first();
            let iframeId = '_' + Math.random().toString(36).substr(2, 9);

            $modal.find('.modal-content').html(`<iframe src="${$target.data('remote')}?minimal_layout=true" onload="adaptIframe()" id="${iframeId}"></iframe>`);
            let $iframe = $('#' + iframeId);
            $iframe.hide();

            window.adaptIframe = function () {
                if (window.frames.length) {
                    window.frames[window.frames.length - 1].onerror = window.onerror;
                }
// html { overflow-x: hidden; }
                $iframe.contents().find("head")
                    .append($(`
                    <style type='text/css'>
                        #main-container { margin-bottom: 12px; }
                        #page-container.page-header-fixed #main-container {
                            padding-top: 0;
                        }
                        #sidebar, #page-header, #page-footer, .sidebar, .main-header {
                            display:none !important;
                        }
                        #page-container.sidebar-o {
                            padding-left: 0;
                        }
                        .main-container {
                            left: 0px !important;
                            top: 0px !important;
                            padding: 0 60px !important;
                            margin-left: 0px !important;
                            margin-top: 0px !important;
                            margin-bottom: 26px;
                            max-width: 99% !important;
                        }
                        .layout-container.view {
                            max-width: 100% !important
                        }
                        @media(max-width:992px) {
                            .main-container {
                                padding: 0 !important;
                            }
                        }
                     </style>`));
                $iframe.show();
                $iframe.height('67.5vh');
                $iframe.css('border', 0);

                // Setting it to iframe contents height is too low
                // $iframe.height($iframe.contents().height());
            };
        });

        // Every time modal hides
        $editUserModal.on('hide.bs.modal', function (e) {
        });

        // When button confirm is clicked
        $editUserModal.find('.btn-confirm').on('click', function (e) {
        });

        // When button cancel is clicked
        $editUserModal.find('.btn-delete').on('click', function (e) {
        });
    }
}
